const STORE_KEY = '@@common'
export const CHANGE_CART_NAME = `${STORE_KEY}/CHANGE_CART_NAME`
